import * as React from 'react';
import styled from 'styled-components';
import {getPayments} from 'api/student/requests';
import {PaymentObject} from 'api/student/types';
import useLoading from 'hooks/use-loading';
import validateResponse from 'helpers/validate-response';
import isError from 'helpers/isError';
import Container from 'containers/Container';
import PaymentTable from 'components/PaymentTable';
import BoxContainer from 'containers/BoxContainer';
import UserStore, {Role} from '../stores/UserStore';
import {Helmet} from 'react-helmet';

const Wrapper = styled(BoxContainer)`
  padding: 20px;
`;

/**
 * Get the page component
 * @return {JSX.Element}
 */
export default function Payments() {
  const {fetch, data, render} = useLoading<PaymentObject[]>();

  React.useEffect(() => {
    switch (UserStore.state?.role) {
      case Role.Student: return (
        fetch(() => new Promise((resolve) => {
          return getPayments().then((response) => {
            validateResponse(response);

            if (response && !isError(response)) {
              resolve(response);
            }
          });
        }))
      )
    }
  }, []);

  /**
   * Render content.
   * @return {JSX.Element}
   */
  function renderContent(): JSX.Element {
    return (
      <Container>
        <Wrapper>
          {data && (
            <PaymentTable
              payments={data}
            />
          )}
        </Wrapper>
      </Container>
    );
  }

  /**
   * Render not found.
   * @return {JSX.Element}
   */
  function renderNotFound(): JSX.Element {
    return (
      <div>
        Not found
      </div>
    );
  }

  return (
    <React.Fragment>
      <Helmet>
        <title>GrowPlace / Оплаты</title>
      </Helmet>
      {render(renderContent, renderNotFound)}
    </React.Fragment>
  );
}
